import type { RouteObject } from "react-router-dom";
import NotFound from "@/pages/NotFound";
import Home from "@/pages/home/page";
import ArticlePage from "@/pages/article/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/vigorbuy-spreadsheet-guide",
    element: <ArticlePage />,
  },
  {
    path: "/vigorbuy-spreadsheet-shoes",
    element: <ArticlePage />,
  },
  {
    path: "/vigorbuy-spreadsheet-safety",
    element: <ArticlePage />,
  },
  {
    path: "/vigorbuy-spreadsheet-review",
    element: <ArticlePage />,
  },
  {
    path: "/vigorbuy-spreadsheet-categories",
    element: <ArticlePage />,
  },
  {
    path: "/vigorbuy-spreadsheet-beginner",
    element: <ArticlePage />,
  },
  {
    path: "/vigorbuy-spreadsheet-hoodies",
    element: <ArticlePage />,
  },
  {
    path: "/vigorbuy-spreadsheet-jackets",
    element: <ArticlePage />,
  },
  {
    path: "/vigorbuy-spreadsheet-accessories",
    element: <ArticlePage />,
  },
  {
    path: "/vigorbuy-spreadsheet-update",
    element: <ArticlePage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;